// Transforms an EMS Scene visit note + visit into the grouped shape the
// visit-note preview renders. Ported from the PRP provider portal.
export const getSortedSceneSummeryData = (
  visitNoteData: any,
  visitData: any,
) => {
  return {
    initialData: {
      incidentDate: visitData?.incidentDate || "-",
      incidentTime: visitData?.incidentTime || "-",
      unitDesignation: visitData?.unitDesignation || "-",
      unitType: visitData?.unitType || "-",
    },

    demographics: {
      dob: visitData?.patient?.participant?.dateOfBirth || "-",
      age: `${visitData?.patient?.participant?.age}` || "-",
      gender: visitData?.patient?.participant?.gender || "-",
      registrationId: visitData?.patient?.participant?.registrationId || "-",
      participantType: visitData?.patient?.participant?.participantType,
      unitNumber: visitData?.participant?.baseCamp?.unitNumber || "-",
      contactNumber: visitData?.patient?.participant?.contactNumber || "-",
    },

    incidentLocation: {
      incidentlocation: visitData?.incidentlocation || "-",
      chiefComplaints: visitData?.chiefComplaints || "-",
      witnessName: visitData?.witnessName || "-",
      witnessContact: visitData?.witnessContact || "-",
    },

    soapAndProc: {
      chiefComplaints: visitNoteData?.chiefComplaints || "-",
      subjectiveNote: visitNoteData?.subjectiveNote || "-",
      objectiveNote: visitNoteData?.objectiveNote || "-",
      assessment: visitNoteData?.assessmentDescription || "-",
      procedureDone: visitNoteData?.procedureDone || "-",
      vitals: visitData?.triage,
    },

    disposition: {
      impressionDiagnosis:
        visitNoteData?.disposition?.[0]?.impressionDiagnosis || "-",
      transferringUnit:
        visitNoteData?.disposition?.[0]?.transferringUnit || "-",
      dispositionData: visitNoteData?.disposition?.[0]?.dispositons,
      refusalOfMedicalAid: visitNoteData?.disposition?.[0]?.refusalOfMedicalAid,
      hospitalName: visitNoteData?.disposition?.[0]?.hospitalName || "-",
    },

    treatedAndRelease: {
      treatAndReleaseSelected:
        visitNoteData?.disposition?.[0]?.dispositons?.treatedAndReleased
          ?.radioButton || false,
      select:
        visitNoteData?.disposition?.[0]?.dispositons?.treatedAndReleased
          ?.select || false,
      signature:
        visitNoteData?.disposition?.[0]?.dispositons?.treatedAndReleased
          ?.signature,
    },
    iftSoapNote: visitNoteData?.iftSoapNote || "-",

    signature: {
      signature: visitNoteData?.disposition?.[0]?.signature?.signature,
      primaryClinic: visitNoteData?.disposition?.[0]?.signature?.primaryClinic,
      timeCallEnd: visitNoteData?.disposition?.[0]?.signature?.timeCallEnd,
    },
  };
};
